import { useFrame } from '@react-three/fiber';

export default function FovCorrection() {
  useFrame(({ camera }) => {
    // when vertical, aspect is < 1
    // when horizontal, aspect is > 1
    if (camera.aspect < 1) return;
    // when horizontal, "undo" the fov aspect 
    // multiplier that three.js applies (using
    // the existing aspect value otherwise
    // we'll distort the camera output)
    const targetFov = camera.fov * camera.aspect;
    if (camera.fov === targetFov) return;
    camera.fov = targetFov;
    // make sure to recompute cause we changed the fov
    camera.updateProjectionMatrix();
  });

  return null;
};
